























































import Vue from 'vue'
import config from '@/utils/config'
import CimissDataService from '@/service/CimissDataService'
import moment from 'moment/moment'
import request from '@/utils/request'
import warningImg from '@/utils/warningImg'
export default Vue.extend({
  mounted() {
    this.getWarninfoData()
  },
  props: {
    type: { type: Number },
  },
  data() {
    return {
      warnInfos: [] as any[],
      modalShow: false,
      alarm: {},
    }
  },
  methods: {
    getWarninfoData() {
      const params = {
        areaCode: config.defaultStationObj.adminCode + '000000',
        startTime: moment().add(-60, 'h').format('YYYY-MM-DD'),
        endTime: moment().format('YYYY-MM-DD')
      }
      CimissDataService.warningSignalList( config.defaultStationObj.adminCode).then((res: any) => {
      // request.get('/warninfo/getEarlyWarnHisInfo', params).then(res => {
        
        if (res) {
          const alarms = res
          this.warnInfos = alarms.filter((e: any) => {
            e.imgUrl = warningImg.getImgSrc(`${e.signaltype}${e.signallevel}`)
            e.fyzn = warningImg.getFyzn(`${e.signaltype}${e.signallevel}`)
            return e
          })

        } else {
          this.warnInfos = []
        }
      });
    },

    showModal(item: any) {
      this.alarm = item
      this.modalShow = true
    },
    toInfo(early_id: string) {
      this.$router.push('/warn_info?id=' + early_id)
    },
    dateStr(dateStr: string, formater: string) {
      if (formater === '') {
        formater = '$1-$2-$3 $4:$5:$6'
      }
      let pattern = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
      //将时间格式化成 yyyy-MM-dd HH:mm:ss
      let formatDateStr = dateStr.toString().replace(pattern, formater);
      return formatDateStr;
    }
  }
})
